import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import styles from './styles';
import type { filterLabelsType } from '../utils/filterUtils';

interface FiltersProps {
  filterLabels: filterLabelsType;
}

const Filters: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<FiltersProps>>> = (props) => {
  const { filterLabels } = props;
  const { bedroomsLabel, propertyTypesLabel, distanceLabel, amenitiesLabel } = filterLabels;
  return (
    <View style={[styles.flexRow, styles.marginBottomSm]}>
      <Text style={styles.body}>Filters applied:</Text>
      <Text style={styles.filter}>{distanceLabel}</Text>
      <Text style={styles.filter}>{bedroomsLabel}</Text>
      <Text style={styles.filter}>{propertyTypesLabel}</Text>
      <Text style={styles.filter}>{amenitiesLabel}</Text>
    </View>
  );
};

export default Filters;
